import {useSummerTShirtPromoTest} from './featureFlags';

export const SUMMER_DISCOUNT_CATEGORY_IDS = [
  16, 17, 18, 20, 60, 83, 84, 86, 88, 89, 104, 109, 110, 113, 124, 247, 399,
  434, 435, 451, 460, 505, 514, 607
];

export function isTshirtSummerPromoEligible(isSiteWideSearch, categoryId) {
  return (
    !isSiteWideSearch &&
    SUMMER_DISCOUNT_CATEGORY_IDS.includes(Number(categoryId))
  );
}

export function useTshirtSummerPromo({categoryId, isSiteWideSearch}) {
  const {
    error: isSummerTShirtPromoTestError,
    isLoading: isSummerTShirtPromoTestLoading,
    variation: summerTShirtPromoTestVariation
  } = useSummerTShirtPromoTest();

  const tshirtSummerPromoEligible = isTshirtSummerPromoEligible(
    isSiteWideSearch,
    categoryId
  );

  const isEnabled =
    !isSummerTShirtPromoTestError && summerTShirtPromoTestVariation === 'test';

  return {
    isEligible: tshirtSummerPromoEligible,
    isEnabled,
    isLoading: isSummerTShirtPromoTestLoading
  };
}
